import React, { useLayoutEffect } from 'react';
import ReactGa from 'react-ga4';
import CentumNewIntroduceMobile from './designcomponents/centumnewintroducemobile';

// 디자인(센텀점 선공개 Mobile.html)은 모바일 전용 — 분기 없이 모바일 컴포넌트 1종만 렌더한다.
// 넓은 화면에서는 컴포넌트 내부에서 max-width:500px 로 가운데 정렬되고 양옆은 회색 캔버스로 채워진다.
export default function CentumNewIntroduce() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    ReactGa.send({ hitType: 'pageview', page_title: 'centum_newintroduce' });
  }, []);
  return <CentumNewIntroduceMobile />;
}
